document.addEventListener("BSS:changeVariantQV", e => {
  setTimeout(() => {
    const labelQvs = document.querySelectorAll('.product-variant__label')
    if (labelQvs.length > 1) {
        labelQvs.forEach(labelQv => {
            const quickViewCard = labelQv.closest('[bss-b2b-quickview-product-form]');
            if (!quickViewCard) return;

            const productFormId = quickViewCard.getAttribute('bss-b2b-product-form-id');
            if (!productFormId) return;

            const productForm = document.querySelector(
                `[bss-b2b-quickview-product-form][bss-b2b-product-form-id="${productFormId}"]`
            );

            if (productForm) {
                console.log('Variant changed -> triggering observer for', productFormId);

                setTimeout(() => {
                    BSS_B2B.observer.productSubject.notifyObserver(
                        'VariantChange',
                        'VariantSelectChange',
                        { productForm }
                    );
                }, 300);
            }
        });
    }
    
    const productForm = document.querySelector("[bss-b2b-main-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
  }, 300);
});

document.addEventListener('DOMContentLoaded', function () {
  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('cart__total') || item.target.classList?.contains('search-results-container')) {
            window.dispatchEvent(new Event("scroll"));
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
        setTimeout(() => {
            document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
        }, 1000)
    }
  });
});
